export enum SourceType {
  Console = "Console",
  Api = "Api", // integration apis
  Customer = "Customer", //customer web app
  Agent = "Agent", // mobile apps
  Shipper = "Shipper" //shipper web app
}
